<template>
  <div>
    <form-alert
      :type="alertText.type"
      :message="alertText.message"
      @close="closeFormAlert"
    />

    <form
      enctype="multipart/form-data"
      ref="uploadForm"
      lazy-validation
      class="inline"
    >
      <div :class="urlModelo ? 'dropbox-download dropbox' : 'dropbox'">
        <input
          type="file"
          @change="filesChange($event.target.files)"
          :multiple="multiplo"
          :name="idDocumento"
          class="input-file"
          accept=".png, .jpg, .zip, .pdf, .doc, .docx, .ppt, .pptx, .xls, .xlsx"
        />

        <span class="custom-anexo" @change="filesChange($event.target.files)">
          <p>
            <v-icon>attach_file</v-icon>
          </p>

          <p>Arraste ou clique aqui</p>
          <div class="float-right">
            <v-chip
              v-if="documentos && documentos.length"
              @click="documentosDialog = true"
              >+ {{ documentos.length }}
              {{ documentos.length == 1 ? "anexo" : "anexos" }}</v-chip
            >
          </div>
        </span>
      </div>

      <v-tooltip class="pl-0 pr-0" slot="append" bottom v-if="urlModelo">
        <v-icon
          class="icon-save pl-2 pr-2"
          slot="activator"
          @click="downloadModelo()"
          >save_alt</v-icon
        >
        <span>Download do modelo de documento</span>
      </v-tooltip>
    </form>

    <v-dialog v-model="documentosDialog" max-width="60vh">
      <base-modal>
        <h2 class="title mb-4">Documentos anexados</h2>

        <v-layout row wrap>
          <v-flex v-for="(arquivo, index) in documentos" :key="index" xs12>
            <v-icon class="pb-1">insert_drive_file</v-icon>
            <span class="compact-text">{{ arquivo.nome }}</span>
            <v-icon class="close_icon" @click="removeFile(index)">close</v-icon>
          </v-flex>

          <v-flex xs4 offset-xs8 pt-0>
            <button
              class="button jns-button yellow-button flex"
              @click="documentosDialog = false"
            >
              Fechar
            </button>
          </v-flex>
        </v-layout>
      </base-modal>
    </v-dialog>
  </div>
</template>

<script lang="js">
import ViewMixin from "@/mixins/ViewMixin";

export default {
  name: "DocumentoUpload",
  mixins: [ViewMixin],
  props: {
    idDocumento: Number,
    arquivos: Array,
    urlModelo: String,
    multiplo: { type: Boolean, default: true },
  },
  data: () => ({
    documentosDialog: false,
    documentos: undefined,
  }),
  methods: {
    removeFile(index) {
      if (this.documentos.length == 1) {
        this.$nextTick();
        this.$refs.uploadForm.reset();
        this.documentos = [];
        this.documentosDialog = false;
      } else this.documentos.splice(index, 1);

      this.$forceUpdate();
    },

    validExtension(file) {
      if (!/\.(jpg|png|pdf|zip|doc|docx|ppt|pptx|xls|xlsx)$/i.test(file.name)) {
        this.$store.commit("SET_ALERT_TEXT", {
          type: "error",
          message:
            "Seu arquivo não é do formato correto. Tente novamente com um arquivo de extensão PDF, ZIP, DOC, DOCX, PPT, PPTX, XLS ou XLSX.",
        });
        this.alertText = this.handleAlertText();

        return false;
      } else return true;
    },

    filesChange(fileList) {
      if (fileList) {
        if (!this.documentos) this.documentos = [];

        /* tem que fazer casting
        pra array caso queira usar array methods */
        Array.from(fileList).forEach((file) => {
          let reader = new FileReader();
          reader.addEventListener(
            "load",
            () => {
              if (this.validExtension(file))
                if (this.multiplo) {
                  let arquivoJaInserido = false;
                  this.documentos.forEach((item) => {
                    if (item.arquivo == reader.result) arquivoJaInserido = true;
                  });

                  if (!arquivoJaInserido)
                    this.documentos.push({
                      nome: file.name,
                      arquivo: reader.result,
                    });
                } else
                  this.documentos = [
                    {
                      nome: file.name,
                      arquivo: reader.result,
                    },
                  ];
            },
            false
          );
          reader.readAsDataURL(file);
        });
        this.$forceUpdate();
      }
    },

    downloadModelo() {
      var fileLink = document.createElement("a");

      fileLink.href = this.urlModelo;
      fileLink.setAttribute("download", "");
      fileLink.setAttribute("target", "_blank");
      document.body.appendChild(fileLink);

      fileLink.click();
    },
  },
  mounted() {
    this.documentos =
      this.arquivos && this.arquivos.length
        ? JSON.parse(JSON.stringify(this.arquivos))
        : this.documentos;
  },
  watch: {
    documentos: function (data) {
      this.$emit("select", { idDocumento: this.idDocumento, arquivos: data });
    },
  },
};
</script>

<style lang="scss" scoped>
.compact-text {
  display: inline-block;
  max-width: 42vh !important;
}

.dropbox {
  outline: 2px dashed #c2c2c2; /* the dash box */
  outline-offset: -10px;
  color: dimgray;
  padding: 10px 10px;
  padding: 25px;
  padding-top: 50px;
  min-height: 193px; /* minimum height */
  position: relative;
  cursor: pointer;
  width: 100%;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;

  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  background: #eee; /* when mouse over to the drop zone, change color */
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;

  color: #a5a5a5;
  font-size: 14px;
  font-weight: bold;
}
.list-unstyled {
  list-style: none;
}
.remove-button {
  display: inline-block;
  z-index: 99;
  position: absolute;
  top: 20px;
  right: 20px;
  text-decoration: none;
}

.custom-anexo {
  top: 1vh;
  position: absolute;
  overflow: hidden;
  width: 100%;
}

.inline {
  .dropbox-download {
    box-shadow: 2px 0 0 0 #c2c2c2;
  }
  .v-tooltip i {
    height: 5vh;
    outline: 2px solid #c2c2c2;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DocumentoUpload.vue